import React, { Component } from "react";
import {
  /* Container,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid, */
  InputLabel,
  Select,
  /* Typography, */
  MenuItem,
  Box,
  FormControl,
  Input,
  FormControlLabel,
  Checkbox,
  TextField,
  FormHelperText,
  /* FormHelperText, */
} from "@mui/material";
import { withStyles } from "@material-ui/core/styles";
import ApiService from "../../ApiService";
import { Alert } from "@mui/material";
import Button from "../../components/Custom/Button/Button";

const useStyles = (theme) => ({
  topCard: {
    marginTop: theme.spacing(1),
    minHeight: "100vh",
  },
  large: {
    width: theme.spacing(10),
    height: theme.spacing(10),
    marginBottom: 10,
  },
});

class EditUserForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: null,
      userName: null,
      password: this.generatePassword(),
      roleId: null,
      role: null,
      roles: [],
      userMerchantIds: [],
      merchants: [],
      userMerchantId: null,
      email: null,
      firstName: null,
      lastName: null,
      phone: null,
      city: null,
      address: null,
      state: null,
      country: null,
      zip: null,
      active: false,
      responseMessage: null,
      failed: false,
      success: false,
      portalPassword: null,
      signkey: null,
      industry: null,
      merchantName: null,
      orgRegistrationNumber: null,
      website: null,
      isIpWhiteList: true,
      isCardWhiteList: true,
      isMasterMerchant: false,
      isSubMerchant: false,
      isAdmin: false,
      isReseller: false,
      merchantCity: null,
      merchantCountry: null,
      merchantZip: null,
      merchantAddress: null,
      merchantPhone: null,
      editingUser: false,
      resellerCharge: null,
      resellerWeeklyLimit: null,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleRoleChange = this.handleRoleChange.bind(this);
    this.fetchAllMerchants = this.fetchAllMerchants.bind(this);
    this.fetchUserRoles = this.fetchUserRoles.bind(this);
    this.startEditUser = this.startEditUser.bind(this);
    this.stopEditUser = this.stopEditUser.bind(this);
    this.saveSelectRoleValue = this.saveSelectRoleValue.bind(this);
  }

  generatePassword = (
    length = 20,
    wishlist = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!@-#$"
  ) =>
    Array(length)
      .fill("")
      .map(
        () =>
          wishlist[
            Math.floor(
              (crypto.getRandomValues(new Uint32Array(1))[0] /
                (0xffffffff + 1)) *
                wishlist.length
            )
          ]
      )
      .join("");

  generateSignkey = (
    length = 12,
    wishlist = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"
  ) =>
    Array(length)
      .fill("")
      .map(
        () =>
          wishlist[
            Math.floor(
              (crypto.getRandomValues(new Uint32Array(1))[0] /
                (0xffffffff + 1)) *
                wishlist.length
            )
          ]
      )
      .join("");

  handleInputChange(event) {
    const target = event.target;
    const inputName = target.name;
    const inputValue = target.value;

    this.setState({
      [inputName]: inputValue,
    });
  }
  // handleRoleChange(event) {
  //   this.handleInputChange(event);
  //   this.setState({ roleId: event.target.value.id });
  //  this.saveSelectRoleValue(event.target.value.type);
  // }

  // saveSelectRoleValue(type) {
  //   if (type === "ADMIN") {
  //     this.setState({
  //       isMasterMerchant: false,
  //       isSubMerchant: false,
  //       isAdmin: true,
  //     });
  //   } else if (type === "SUBMERCHANT") {
  //     this.setState({
  //       isMasterMerchant: false,
  //       isSubMerchant: true,
  //       isAdmin: false,
  //     });
  //   } else if (type === "MERCHANT") {
  //     this.setState({
  //       isMasterMerchant: true,
  //       isSubMerchant: false,
  //       isAdmin: false,
  //       signkey: Math.random().toString(16).slice(-8),
  //     });
  //   }
  // }

  handleRoleChange(event) {
    this.handleInputChange(event);
    this.setState({ roleId: event.target.value.id });
    this.saveSelectRoleValue(event.target.value.type);
  }
  saveSelectRoleValue(type) {
    if (type === "ADMIN") {
      this.setState({
        isMasterMerchant: false,
        isSubMerchant: false,
        isReseller: false,
        isAdmin: true,
      });
    } else if (type === "SUBMERCHANT") {
      this.setState({
        isMasterMerchant: false,
        isReseller: false,
        isSubMerchant: true,
        isAdmin: false,
      });
    } else if (type === "RESELLER") {
      this.setState({
        isMasterMerchant: false,
        isSubMerchant: false,
        isAdmin: false,
        isReseller: true,
      });
    } else if (type === "MERCHANT") {
      this.setState({
        isMasterMerchant: true,
        isSubMerchant: false,
        isReseller: false,
        isAdmin: false,
        signkey: Math.random().toString(16).slice(-8),
      });
    }
  }

  startEditUser() {
    this.setState({ editingUser: true });
  }
  stopEditUser() {
    this.setState({ editingUser: false });
  }
  componentDidMount() {
    this.fetchAllMerchants();
    this.fetchUserRoles();
    this.setState({
      firstName: this.props.currentUser.firstName,
      lastName: this.props.currentUser.lastName,
      userName: this.props.currentUser.userName,
      password: this.props.currentUser.password,
      role: this.props.currentUser.role,
      roleId: this.props.currentUser.role.id,
      email: this.props.currentUser.email,
      phone: this.props.currentUser.phone,
      address: this.props.currentUser.address,
      city: this.props.currentUser.city,
      country: this.props.currentUser.country,
      zip: this.props.currentUser.zip,
      active: this.props.currentUser.active,
      userId: this.props.currentUser.id,
    });
  }
  fetchUserRoles() {
    ApiService.fetchUserRoles().then((res) => {
      const roles = res.data;

      const role =
        roles.filter((obj) => obj.id === this.props.currentUser.role.id)[0] ||
        this.props.currentUser.role;

      this.setState({
        roles: roles,
        role: role,
        roleId: role.id,
      });
      this.saveSelectRoleValue(role.type);
    });
  }

  fetchAllMerchants() {
    ApiService.fetchAllMerchants().then((res) => {
      this.setState({ merchants: res.data });
      /* const merchants = res.data; */
    });
  }
  handleCheckboxChange(event) {
    if (event.target.checked) this.setState({ active: true });
    else this.setState({ active: false });
  }
  handleSubmit() {
    var request = Object.assign({}, this.state);

    ApiService.updateUser(request)
      .then((res) => {
        if (res.data.status === "OK") {
          this.setState({
            failed: false,
            success: true,
            responseMessage: res.data.responseMessage,
          });
          this.props.reloadData();
          this.props.onClose();
        } else
          this.setState({
            failed: true,
            success: false,
            responseMessage: res.data.responseMessage,
          });
      })
      .catch((e) => {
        this.setState({ failed: true, responseMessage: "Error" });
      });
  }

  render() {
    /* const { classes } = this.props; */

    return (
      <form>
        {this.state.failed && (
          <Alert severity="error" elevation="0">
            {" "}
            {this.state.responseMessage}
          </Alert>
        )}
        {this.state.success && (
          <Alert severity="success" elevation="0">
            {this.state.responseMessage}
          </Alert>
        )}

        <TextField
          name="userName"
          placeholder="Username"
          fullWidth
          margin="dense"
          error={this.state.userName == null}
          value={this.state.userName}
          onChange={this.handleInputChange}
          disabled
          helperText={this.state.userName == null && "Value is required"}
        />

        <TextField
          name="email"
          placeholder="Email"
          fullWidth
          error={this.state.email == null}
          margin="dense"
          type="email"
          value={this.state.email}
          onChange={this.handleInputChange}
          required
          helperText={this.state.email == null && "Value is required"}
        />

        <FormControl fullWidth margin="dense">
          <Input
            name="phone"
            placeholder="Phone"
            value={this.state.phone}
            onChange={this.handleInputChange}
          />
        </FormControl>
        <FormControl fullWidth margin="dense">
          <Input
            name="firstName"
            placeholder="First Name"
            value={this.state.firstName}
            onChange={this.handleInputChange}
            required
          />
        </FormControl>
        <FormControl fullWidth margin="dense">
          <Input
            name="lastName"
            placeholder="Last Name"
            value={this.state.lastName}
            onChange={this.handleInputChange}
            required
          />
        </FormControl>
        <FormControl fullWidth margin="dense">
          <Input
            name="address"
            placeholder="Address"
            value={this.state.address}
            onChange={this.handleInputChange}
          />
        </FormControl>
        <FormControl fullWidth margin="dense">
          <Input
            name="city"
            placeholder="City"
            value={this.state.city}
            onChange={this.handleInputChange}
            required
          />
        </FormControl>
        <FormControl fullWidth margin="dense">
          <Input
            name="country"
            placeholder="Country"
            value={this.state.country}
            onChange={this.handleInputChange}
          />
        </FormControl>
        <FormControl fullWidth margin="dense">
          <Input
            name="zip"
            placeholder="Zip"
            value={this.state.zip}
            onChange={this.handleInputChange}
          />
        </FormControl>
        <FormControl fullWidth margin="dense">
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.active}
                onChange={this.handleCheckboxChange}
                name="active"
                id="active"
                color="primary"
              />
            }
            label="Is Active"
          />
        </FormControl>
        {this.state.isSubMerchant && (
          <FormControl fullWidth margin="dense">
            <InputLabel id="merchantsLable">Select Merchant</InputLabel>
            <Select
              value={this.state.userMerchantId}
              onChange={this.handleInputChange}
              name="userMerchantId"
              labelId="merchantsLable"
              id="userMerchantId"
            >
              <MenuItem key="" value="">
                &nbsp;{" "}
              </MenuItem>
              {this.state.merchants &&
                this.state.merchants.map((m) => (
                  <MenuItem key={m.id} value={m.id} dense>
                    {" "}
                    {m.merchantName + "-" + m.code}{" "}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        )}

        {this.state.isReseller && (
          <div>
            <FormControl required fullWidth margin="dense">
              <InputLabel id="merchantsLables">Select Merchant</InputLabel>
              <Select
                labelId="merchantsLables"
                id="userMerchantIds"
                name="userMerchantIds"
                multiple
                value={this.state.userMerchantIds}
                onChange={this.handleInputChange}
                renderName={(selected) => selected.join(", ")}
              >
                {this.state.merchants &&
                  this.state.merchants.map((m) => (
                    <MenuItem
                      key={m.id}
                      value={m.id}
                      name={m.merchantName}
                      dense
                    >
                      {" "}
                      {m.merchantName + "-" + m.code}{" "}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </div>
        )}

        <Box align="center">
          <Button
            onClick={this.handleSubmit}
            variant="contained"
            color="primary"
          >
            Update{" "}
          </Button>
        </Box>
      </form>
    );
  }
}
export default withStyles(useStyles)(EditUserForm);
